import * as actionTypes from "./types";

export const initPage = () => ({
  type: actionTypes.INIT_ADMIN_SAV,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/sav.json`,
    method: "GET"
  },
  payload: {
  },
});

// isDelay : le message annonce un retard — seuls ceux-là sont montrés au
// client dans l'app (frise « Incident » du suivi de commande).
export const sendSMS = (orderIds, cause, start, end, customContent = null, appendIntendancePhone = false, isDelay = false) => ({
  type: actionTypes.SAV_SEND_SMS,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/sav/sendsms.json`,
    method: "POST",
    body: {
      orderIds: orderIds,
      cause   : cause,
      start   : start,
      end     : end,
      customContent: customContent,
      appendIntendancePhone: appendIntendancePhone,
      isDelay: isDelay
    },
  },
});

export const sendEmail = (orderIds, emailContent, isDelay = false) => ({
  type: actionTypes.SAV_SEND_EMAIL,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/sav/sendemail.json`,
    method: "POST",
    body: {
      orderIds:     orderIds,
      emailContent: emailContent,
      isDelay:      isDelay
    },
  },
});

/**
 * Récupère les tournées (charrettes) avec leurs points de livraison ordonnés
 * (même endpoint que la page /itineraires-b2c de l'app livraison)
 */
export const getItineraries = (date) => ({
  type: actionTypes.SAV_ITINERARIES,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/store/delivery/itineraries.json`,
    method: "GET",
    params: date ? { date: date } : {},
  },
  payload: {}
});

/**
 * Intendance charrette : liste des livreurs actifs
 */
export const getIntendanceDeliverymen = () => ({
  type: actionTypes.INTENDANCE_DELIVERYMEN,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/intendance/deliverymen.json`,
    method: "GET"
  },
  payload: {}
});

/**
 * Intendance charrette : personnes affectées à l'intendance pour une date
 * (une par établissement et/ou une globale)
 */
export const getIntendanceStaff = (date) => ({
  type: actionTypes.INTENDANCE_STAFF,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/intendance/staff.json`,
    method: "GET",
    params: { date: date }
  },
  payload: {}
});

/**
 * Intendance charrette : affecte (ou retire si deliveryManId null) une personne
 * à l'intendance pour une date. establishmentId null = intendance globale.
 */
export const setIntendanceStaff = (date, establishmentId, deliveryManId) => ({
  type: actionTypes.INTENDANCE_SET_STAFF,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/intendance/staff.json`,
    method: "POST",
    body: {
      date: date,
      establishmentId: establishmentId,
      deliveryManId: deliveryManId
    },
  },
  payload: {}
});

/**
 * Intendance charrette : affecte (ou retire si deliveryManId null)
 * un livreur à une charrette pour une date
 */
export const setIntendanceAssignment = (date, vehicleId, deliveryManId) => ({
  type: actionTypes.INTENDANCE_SET_ASSIGNMENT,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/intendance/assignments.json`,
    method: "POST",
    body: {
      date: date,
      vehicleId: vehicleId,
      deliveryManId: deliveryManId
    },
  },
  payload: {}
});

/**
 * Intendance charrette : marque (ou dé-marque) un point comme livré pour une date.
 * État partagé avec l'app livraison via le flag `delivered` des itinéraires.
 */
export const setSpotDelivered = (date, spotId, vehicleId, delivered) => ({
  type: actionTypes.INTENDANCE_SET_DELIVERED,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/store/delivery/spots/${spotId}/delivered.json`,
    method: "POST",
    body: {
      date: date,
      vehicleId: vehicleId,
      delivered: delivered
    },
  },
  payload: {}
});

/**
 * Intendance charrette : ids des points livrés pour une date (endpoint minimal,
 * pollé pour voir les coches posées par les livreurs sans recharger la page)
 */
export const getDeliveredSpots = (date) => ({
  type: actionTypes.INTENDANCE_DELIVERED_SPOTS,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/store/delivery/delivered.json`,
    method: "GET",
    params: { date: date }
  },
  payload: {}
});

/**
 * Intendance charrette : historique des notes (par charrette ou par point)
 */
export const getIntendanceNotes = (params) => ({
  type: actionTypes.INTENDANCE_NOTES,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/intendance/notes.json`,
    method: "GET",
    params: params,
  },
  payload: {}
});

/**
 * Intendance charrette : historique des envois SMS/email du jour
 * pour les clients ayant commandé sur les points donnés
 */
export const getIntendanceSendHistory = (params) => ({
  type: actionTypes.INTENDANCE_SEND_HISTORY,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/intendance/sendhistory.json`,
    method: "GET",
    params: params,
  },
  payload: {}
});

/**
 * Intendance charrette : envoie le récap livreurs sur Connecteam
 */
export const sendIntendanceRecapConnecteam = (message) => ({
  type: actionTypes.INTENDANCE_RECAP_CONNECTEAM,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/intendance/recap/connecteam.json`,
    method: "POST",
    body: {
      message: message
    },
  },
  payload: {}
});

/**
 * Intendance charrette : ajoute une note de suivi journalière
 */
export const createIntendanceNote = (params) => ({
  type: actionTypes.INTENDANCE_NOTE_CREATE,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/intendance/notes.json`,
    method: "POST",
    body: params,
  },
  payload: {}
});

export const listPropositionCategories = () => ({
  type: actionTypes.SAV_PROP_CATEGORIES,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/proposition/categories.json`,
    method: "GET"
  },
  payload: {}
});

export const listPropositions = (status = null) => ({
  type: actionTypes.SAV_PROP_LIST,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/sav/proposition.json${status ? `?status=${status}` : ''}`,
    method: "GET"
  },
  payload: {}
});

/**
 * Les SAV d'une période et, au besoin, d'une famille ou d'une sous-catégorie —
 * la liste que Tim relit pour corriger les classements (29/10/2026).
 */
export const searchPropositions = (params = {}) => ({
  type: actionTypes.SAV_PROP_LIST,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/sav/proposition.json`,
    method: "GET",
    params,
  },
  payload: {}
});

/**
 * Reclasse un SAV déjà traité. Seule la catégorie bouge : ni le montant, ni le
 * message parti au client.
 */
export const updatePropositionCategory = (id, savCategory) => ({
  type: actionTypes.SAV_PROP_SET_CATEGORY,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/proposition/${id}/category.json`,
    method: "PUT",
    body: { savCategory },
  },
  payload: { id, savCategory }
});

/**
 * Le même SAV, mais désigné par son avantage. C'est l'id que le dashboard de
 * pilotage sait donner, et le seul dont disposent les SAV créés hors du tunnel
 * (crédit de masse, import, saisie directe) — un SAV sur cinq.
 */
export const getSavAdvantage = (id) => ({
  type: actionTypes.SAV_ADVANTAGE_GET,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/advantage/${id}.json`,
    method: "GET",
  },
  payload: { id }
});

export const updateSavAdvantageCategory = (id, savCategory) => ({
  type: actionTypes.SAV_ADVANTAGE_SET_CATEGORY,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/advantage/${id}/category.json`,
    method: "PUT",
    body: { savCategory },
  },
  payload: { id, savCategory }
});

/**
 * Pré-remplit un SAV à partir d'un ticket Freshdesk (client, commande, catégorie)
 * et signale un SAV déjà rattaché à ce ticket.
 */
export const getFreshdeskTicket = (ticketId) => ({
  type: actionTypes.SAV_PROP_FRESHDESK,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/sav/proposition/freshdesk/${ticketId}.json`,
    method: "GET"
  },
  payload: {}
});

/**
 * Dernières commandes d'un client, pour rattacher le SAV à l'une d'elles.
 *
 * Volontairement séparée de `getStoreCustomerOrders` (duck customers) : le
 * reducer de celle-ci remplace `customers.customer` par le client passé en
 * payload et y écrase `orders`. L'appeler depuis la modale vidait la fiche
 * client affichée derrière, et n'y laissait que les dernières commandes.
 */
export const listCustomerOrders = (customerId, limit = null) => ({
  type: actionTypes.SAV_PROP_CUSTOMER_ORDERS,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/customers/${customerId}/orders.json`,
    method: "GET",
    ...(limit ? { params: { limit } } : {}),
  },
  payload: {}
});

/**
 * Le barème en entier, pour consultation depuis la fenêtre SAV.
 */
export const getBareme = () => ({
  type: actionTypes.SAV_PROP_BAREME,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/proposition/bareme.json`,
    method: "GET",
  },
  payload: {}
});

/**
 * Produits et ingrédients de la commande, avec leur prix : l'agent choisit
 * celui qui pose problème au lieu d'aller chercher son prix.
 */
export const listOrderItems = (orderId) => ({
  type: actionTypes.SAV_PROP_ORDER_ITEMS,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/proposition/order-items.json`,
    method: "GET",
    params: { orderId },
  },
  payload: {}
});

/**
 * Historique SAV du client (12 mois) : combien de SAV, le dernier, le total crédité.
 */
export const getCustomerSavHistory = (customerId) => ({
  type: actionTypes.SAV_PROP_CUSTOMER_HISTORY,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/proposition/customer-history.json`,
    method: "GET",
    params: { customerId },
  },
  payload: {}
});

/**
 * Proposition de geste d'après le barème, pour la catégorie et la commande en cours.
 */
export const getCompensationSuggestion = (params) => ({
  type: actionTypes.SAV_PROP_COMPENSATION_SUGGESTION,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/proposition/compensation-suggestion.json`,
    method: "POST",
    body: params
  },
  payload: {}
});

/**
 * Réponses types disponibles pour une catégorie de SAV.
 */
export const listResponseTemplates = (savCategory = null) => ({
  type: actionTypes.SAV_PROP_RESPONSE_TEMPLATES,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/proposition/response-templates.json`,
    method: "GET",
    ...(savCategory ? { params: { savCategory } } : {}),
  },
  payload: {}
});

/**
 * Texte de réponse proposé à l'agent avant création du SAV.
 */
export const previewResponse = (params) => ({
  type: actionTypes.SAV_PROP_RESPONSE_PREVIEW,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/sav/proposition/response-preview.json`,
    method: "POST",
    body: params
  },
  payload: {}
});

/**
 * Propositions SAV EN COURS d'un client (réponse du client ou recontact attendus).
 * Lue depuis la promesse, sans passer par le store : la fiche et la modale
 * n'ont besoin que de ce client-là.
 */
export const listCustomerPropositions = (customerId) => ({
  type: actionTypes.SAV_PROP_CUSTOMER_LIST,
  meta: {
    async: true,
    blocking: false,
    path: `/v2/admin/store/sav/proposition.json`,
    method: "GET",
    params: { customerId, inProgress: 1 },
  },
  payload: {}
});

export const createProposition = (params) => ({
  type: actionTypes.SAV_PROP_CREATE,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/sav/proposition.json`,
    method: "POST",
    body: params
  },
  payload: {}
});

export const cancelProposition = (id) => ({
  type: actionTypes.SAV_PROP_CANCEL,
  meta: {
    async: true,
    blocking: true,
    path: `/v2/admin/store/sav/proposition/${id}/cancel.json`,
    method: "POST",
    body: {}
  },
  payload: { id }
});

export const creditPools = (type, params) => {

  let path = `/v2/admin/store/sav/credit.json`;
  if (type === 'customer') {
    path = `/v2/admin/store/sav/credit/bycustomer.json`;
  }
  return {
    type: actionTypes.SAV_CREDIT_POOLS,
    meta: {
      async: true,
      blocking: true,
      path: path,
      method: "POST",
      body: params,
    },
  }
}
